import { filter, some } from "lodash";
import { isPriceEligibleForTrial } from "@circle-react/helpers/paywallPriceHelpers";
import type { Paywall, PaywallStatus } from "@circle-react/types/Paywall";
import { PAYWALL_STATUS } from "@circle-react/types/Paywall";
import type { PaywallPrice } from "@circle-react/types/PaywallPrice";

export const isActive = (paywall: Paywall): boolean =>
  paywall.status === PAYWALL_STATUS.ACTIVE;

export const isInactive = (paywall: Paywall): boolean =>
  paywall.status === PAYWALL_STATUS.INACTIVE;

export const isPaywallEligibleForTrial = (paywall: Paywall): boolean =>
  some(paywall.stripe_prices_attributes, (paywallPrice: PaywallPrice) =>
    isPriceEligibleForTrial(paywallPrice),
  );

export const paywallsEligibleForTrial = (paywalls: Paywall[]): Paywall[] =>
  filter(paywalls, (paywall: Paywall) => isPaywallEligibleForTrial(paywall));

export const isEditingMode = (
  currentPaywallStatus: PaywallStatus | undefined,
): boolean => currentPaywallStatus !== undefined;

export const shouldDisplayWorkflowsTab = (
  currentPaywallStatus: PaywallStatus | undefined,
): boolean =>
  currentPaywallStatus === PAYWALL_STATUS.ACTIVE &&
  isEditingMode(currentPaywallStatus);
